import Get from 'lodash/get';

export const isLoading = state => Get(state, 'printWO.loading', false);
